import InputSecurityCode from './InputSecurityCode';

export default InputSecurityCode;
